'use strict';

define(
    'RaceMtpStatusFac',['lodash'],
    function (_) {
    /**
     * This factory starts a polling to know every race's MTP that is under 120 MTP (2 hours)
     * and will broadcast an event to the entire application when detecting changes.
     * All MTPs across the platform must come from here.
     *
     * @param GraphRacesMtpStatus
     * @param $rootScope
     * @param CookieFac
     * @param $log
     * @returns {{getRaceMtpStatus: getRaceMtpStatus}}
     * @constructor
     */
    function RaceMtpStatusFac(GraphRacesMtpStatus, $rootScope, CookieFac, $log, $filter) {
        var graphqlEnabled = $rootScope.activeFeatures.graphqlEnabled;
        var globalMtpFeature = graphqlEnabled && $rootScope.activeFeatures.globalMtpRefreshSystem;
        var mtpStatusRegistry = {};

        var subscriptionTimer = $filter('CMSLabels')('low', 'graphqlPollingRates') || 30000; // in ms

        function _getWagerProfile() {
            return CookieFac.getCookie('wp') && $rootScope.userSession ? CookieFac.getCookie('wp') : 'PORT-Generic';
        }

        function _onSuccess(result) {
            _.forEach(mtpStatusRegistry, function (race) {
                race.raceStatus = 'RO';
            });

            _.forEach(result, function (race) {
                mtpStatusRegistry[race.raceId] = race;
            });

            $rootScope.$broadcast('mtpStatusUpdated');
        }

        function _subscribe() {
            GraphRacesMtpStatus.subscribe(
                { wagerProfile: _getWagerProfile() },
                { success: _onSuccess, fail: _onError },
                subscriptionTimer,
                true
            );
        }

        function _refreshData() {
            GraphRacesMtpStatus.refetch({ wagerProfile: _getWagerProfile() });
        }

        function _onError() {
            $log.error('Error getting the MTP status via GraphQL');
        }

        (function () {
            // TODO: remove globalMtpRefreshSystem toggle validation from here once is 100% on
            if (globalMtpFeature) {

                // Subscription has to be made after session validation to prevent duplicate requests
                var unbindOnSession = $rootScope.$on('session', function () {
                    _subscribe();
                    unbindOnSession();
                });


                $rootScope.$on('login', function() {
                    _refreshData();
                });

               $rootScope.$on('userLogout', function () {
                    _refreshData();
                });
            }
        }());

        return {
            getRaceMtpStatus: function (raceId) {
                return mtpStatusRegistry[raceId] || {};
            },
            getClosestRaceToBet: function() {
                return _.find(mtpStatusRegistry, function (race) {
                    var code = (race.raceStatus.code || '').toLowerCase();
                    return code === 'ic' || code === 'o' || code === 'mo';
                });
            }
        };
    }

    RaceMtpStatusFac.$inject = [
        'GraphRacesMtpStatus',
        '$rootScope',
        'CookieFac',
        '$log',
        '$filter'
    ];

    return RaceMtpStatusFac;

});

